/* eslint-disable camelcase */
import isEmail from 'validator/lib/isEmail';
// import { navigate } from 'gatsby';
import { AsYouType } from 'libphonenumber-js';
import { captureException } from '@sentry/gatsby';

import { submitDemoToHubspot } from '../../Utilities/hubspotDemoFormApi';
import hotjarIdentifyAPI from '../../../../utils/hotjarIdentify';
import { submitChiliPiper } from '../../Utilities/chiliPiper';

const errorMessages = {
  firstname: 'Please complete required field',
  lastname: 'Please complete required field',
  companyname: 'Please complete required field',
  Number_of_Technicians_Range__c: 'Please complete required field',
};

export const validateEmail = (e, validation, setValidation) => {
  const email = e.target.value;
  if (email === '') {
    setValidation({ ...validation, email: 'Please complete required field' });
    return false;
  }

  if (!isEmail(email)) {
    setValidation({
      ...validation,
      email: `Please provide a valid email address`,
    });
    return false;
  }

  setValidation({ ...validation, email: '' });
  return true;
};

export const validatePhone = (e, validation, setValidation) => {
  const phone = e.target.value;

  const phoneWithoutWhitespace = phone.replace(/\s/g, '');
  const phoneWithoutPlus = phoneWithoutWhitespace.replace('+', '');
  const formattedPhone = phoneWithoutPlus.replace(/-/g, '');
  const validPhoneLength =
    formattedPhone.length > 8 && formattedPhone.length < 16;

  if (phone === '') {
    setValidation({ ...validation, phone: 'Please complete required field' });
    return false;
  }
  if (!validPhoneLength) {
    setValidation({
      ...validation,
      phone: 'Not a valid phone number',
    });
    return false;
  }
  setValidation({ ...validation, phone: '' });
  return true;
};

export const validateOnChange = (e, type, validation, setValidation) => {
  const { value } = e.target;

  if (type === 'email') {
    validateEmail(e, validation, setValidation);
    return false;
  }
  if (type === 'phone') {
    validatePhone(e, validation, setValidation);
    return false;
  }
  if (value === '') {
    setValidation({ ...validation, [type]: errorMessages[type] });
    return false;
  }
  setValidation({ ...validation, [type]: '' });
};

export const handlePhoneOnChange = (
  e,
  validation,
  setValidation,
  data,
  setData
) => {
  e.preventDefault();
  const phone = new AsYouType('US').input(e.target.value);

  if (phone[0] !== '+' && data.countrycode === 'us') {
    e.target.value = `+1 ${phone}`;
  } else {
    e.target.value = phone;
  }
  if (e.target.value === '+') {
    e.target.value = '';
  }

  setData({ ...data, phone: e.target.value });
  validatePhone(e, validation, setValidation);
};

export const validateOnSubmit = (data, validation, setValidation) => {
  const {
    email,
    firstname,
    lastname,
    phone,
    companyname,
    Number_of_Technicians_Range__c,
  } = data;
  const validEmail = validateEmail(
    { target: { value: email } },
    validation,
    setValidation
  );
  if (!validEmail) {
    return {
      valid: false,
      error: 'email',
    };
  }

  if (firstname === '') {
    setValidation({ ...validation, firstname: errorMessages.firstname });
    return {
      valid: false,
      error: 'firstname',
    };
  }
  if (lastname === '') {
    setValidation({ ...validation, lastname: errorMessages.lastname });
    return {
      valid: false,
      error: 'lastname',
    };
  }
  if (phone === '') {
    setValidation({ ...validation, phone: errorMessages.phone });
    return {
      valid: false,
      error: 'phone',
    };
  }
  if (companyname === '') {
    setValidation({ ...validation, companyname: errorMessages.companyname });
    return {
      valid: false,
      error: 'companyname',
    };
  }
  if (Number_of_Technicians_Range__c === '') {
    setValidation({
      ...validation,
      Number_of_Technicians_Range__c:
        errorMessages.Number_of_Technicians_Range__c,
    });
    return {
      valid: false,
      error: 'Number_of_Technicians_Range__c',
    };
  }

  return {
    valid: true,
    error: '',
  };
};

const createDemoPayload = data => {
  const payload = {
    email: data?.email,
    firstname: data?.firstname,
    lastname: data?.lastname,
    phone: data?.phone,
    companyname: data?.companyname,
    Number_of_Technicians_Range__c: data?.Number_of_Technicians_Range__c,
    jobtitle: data?.jobtitle,
    industry: data?.industry,
    country: data?.country,
    state: data?.state,
    url: data?.url,
    gclid: data?.gclid,
    language: data?.language,
    offer: data?.offer,
  };

  return payload;
};

export const handleSubmit = ({
  e,
  data,
  setData,
  validation,
  setValidation,
  customFormHandler,
  closeLightbox,
  chiliPiperRouterId,
}) => {
  e.preventDefault();

  try {
    const { valid, error } = validateOnSubmit(data, validation, setValidation);

    if (!valid) {
      throw new Error(`Invalid form data for field: ${error}`);
    }

    const payload = createDemoPayload(data);
    console.log('Submitting form with payload:', payload);

    submitDemoToHubspot(payload, customFormHandler)
      .then(() => {
        console.log('Form submission successful');
        submitChiliPiper(data, chiliPiperRouterId);

        setData({
          email: '',
          firstname: '',
          lastname: '',
          phone: '',
          companyname: '',
          Number_of_Technicians_Range__c: '',
          jobtitle: '',
          companysize: '',
          url: '',
          industry: '',
          industrydetail: '',
          country: '',
          countrycode: '',
          state: '',
          gclid: '',
        });
        hotjarIdentifyAPI(data);
        closeLightbox();
      })
      .catch(err => {
        console.error('Form submission failed:', err);
        captureException(`Demo Form HubSpot Submission Error - ${err.message}`);
        alert(
          'There was an error submitting the form. Please try again later.'
        );
      });
  } catch (error) {
    captureException(`Demo Form Error - ${error}`);
    console.error('Form validation error:', error);
    alert('Please check all required fields and try again.');
  }
};
